import React, { useEffect, useState } from "react";
import { apiGet, apiPost } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { toast } from "react-toastify";

// =====================================================
// CATEGORY CONFIG
// =====================================================

const CATEGORIES = [
  {
    value: "whatsapp",
    label: "WhatsApp",
    contentField: "whatsappContent",
    showingField: "whatsappShowing",
    inputType: "text",
    placeholder: "919876543210",
  },
  {
    value: "telegram",
    label: "Telegram",
    contentField: "telegramContent",
    showingField: "telegramShowing",
    inputType: "url",
    placeholder: "https://t.me/username",
  },
  
  // {
  //   value: "email",
  //   label: "Email",
  //   contentField: "emailContent",
  //   showingField: "emailShowing",
  //   inputType: "email",
  //   placeholder: "example@gmail.com",
  // },
  // {
  //   value: "skype",
  //   label: "Skype",
  //   contentField: "skypeContent",
  //   showingField: "skypeShowing",
  //   inputType: "text",
  //   placeholder: "Skype username",
  // },
  // {
  //   value: "instagram",
  //   label: "Instagram",
  //   contentField: "instagramContent",
  //   showingField: "instagramShowing",
  //   inputType: "url",
  //   placeholder: "https://instagram.com/username",
  // },
  {
    value: "facebook",
    label: "Facebook",
    contentField: "facebookContent",
    showingField: "facebookShowing",
    inputType: "url",
    placeholder: "https://facebook.com/username",
  },
];

// =====================================================
// COMPONENT
// =====================================================

const Setting = () => {
  // List
  const [settingData, setSettingData] = useState([]);

  // Loading
  const [loading, setLoading] = useState(false);

  // Add/Edit modal
  const [showModal, setShowModal] = useState(false);

  // IMPORTANT: Empty = Add, ID = Edit
  const [editId, setEditId] = useState("");

  // Form
  const [category, setCategory] = useState("telegram");
  const [socialValue, setSocialValue] = useState("");
  const [showingValue, setShowingValue] = useState("");

  // Delete
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  // =====================================================
  // SELECTED CATEGORY
  // =====================================================

  const selectedCategory =
    CATEGORIES.find((item) => item.value === category) ||
    CATEGORIES[0];

  // =====================================================
  // GET SETTINGS
  // =====================================================

  const getSettingData = async () => {
    try {
      const { status, data } = await apiGet(apiPath.getSetting);

      if (status === 200 && data?.success) {
        setSettingData(data?.results || []);
      } else {
        setSettingData([]);
      }
    } catch (error) {
      console.log("getSettingData error:", error);

      toast.error(
        error?.response?.data?.message ||
          "Unable to get setting data"
      );
    }
  };

  // =====================================================
  // INITIAL LOAD
  // =====================================================

  useEffect(() => {
    getSettingData();
  }, []);

  // =====================================================
  // RESET FORM
  // =====================================================

  const resetForm = () => {
    setEditId("");
    setCategory("telegram");
    setSocialValue("");
    setShowingValue("");
  };

  // =====================================================
  // OPEN ADD
  // =====================================================

  const openAddModal = () => {
    resetForm();
    setShowModal(true);
  };

  // =====================================================
  // OPEN EDIT
  // =====================================================

  const openEditModal = (item) => {
    console.log("EDIT ITEM:", item);

    if (!item?._id) {
      toast.error("Invalid setting ID");
      return;
    }

    const categoryData = CATEGORIES.find(
      (x) => x.value === item.category
    );

    if (!categoryData) {
      toast.error("Invalid category");
      return;
    }

    // VERY IMPORTANT
    // Save existing MongoDB ID
    setEditId(item._id);

    // Category
    setCategory(item.category);

    // Content
    setSocialValue(
      item[categoryData.contentField] || ""
    );

    // Showing
    setShowingValue(
      item[categoryData.showingField] || ""
    );

    setShowModal(true);
  };

  // =====================================================
  // CLOSE MODAL
  // =====================================================

  const closeModal = () => {
    setShowModal(false);
    resetForm();
  };

  // =====================================================
  // CATEGORY CHANGE
  // =====================================================

  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
    setSocialValue("");
    setShowingValue("");
  };

  // =====================================================
  // CONTENT LABEL
  // =====================================================

  const getContentLabel = () => {
    switch (category) {
      case "telegram":
        return "Telegram Link";

      case "whatsapp":
        return "WhatsApp Number / Link";

      case "email":
        return "Email Address";

      case "skype":
        return "Skype ID";

      case "instagram":
        return "Instagram Link";

      case "facebook":
        return "Facebook Link";

      default:
        return "Content";
    }
  };

  // =====================================================
  // SUBMIT ADD / UPDATE
  // =====================================================

  const onSubmit = async () => {
    // Validation
    if (!category) {
      toast.error("Please select category");
      return;
    }

    if (!socialValue.trim()) {
      toast.error(
        `${getContentLabel()} is required`
      );
      return;
    }

    setLoading(true);

    try {
      const contentField =
        selectedCategory.contentField;

      const showingField =
        selectedCategory.showingField;

      // =================================================
      // PAYLOAD
      // =================================================

      const payload = {
        category: category,

        [contentField]: socialValue.trim(),

        [showingField]:
          showingValue.trim() ||
          selectedCategory.label,
      };

      // =================================================
      // IMPORTANT FOR UPDATE
      // =================================================

      if (editId) {
        payload.settingId = editId;
      }

      console.log(
        editId
          ? "UPDATE PAYLOAD:"
          : "ADD PAYLOAD:",
        payload
      );

      // =================================================
      // API
      // =================================================

      const {
        status,
        data,
      } = await apiPost(
        apiPath.addUpdateSetting,
        payload
      );

      console.log("API RESPONSE:", data);

      if (status === 200 && data?.success) {
        toast.success(
          data?.message ||
            (editId
              ? "Setting updated successfully"
              : "Setting added successfully")
        );

        closeModal();

        // Reload data
        await getSettingData();
      } else {
        toast.error(
          data?.message ||
            "Something went wrong"
        );
      }
    } catch (error) {
      console.log(
        "addUpdateSetting error:",
        error
      );

      toast.error(
        error?.response?.data?.message ||
          "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  // =====================================================
  // DELETE
  // =====================================================

  const openDeleteModal = (id) => {
    if (!id) {
      toast.error("Invalid setting ID");
      return;
    }

    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteId("");
    setShowDeleteModal(false);
  };

  const onDelete = async () => {
    if (!deleteId) {
      toast.error("Invalid setting ID");
      return;
    }

    setLoading(true);

    try {
      const {
        status,
        data,
      } = await apiPost(
        apiPath.deleteSetting,
        {
          settingId: deleteId,
        }
      );

      if (status === 200 && data?.success) {
        toast.success(
          data?.message ||
            "Setting deleted successfully"
        );

        closeDeleteModal();

        await getSettingData();
      } else {
        toast.error(
          data?.message ||
            "Unable to delete setting"
        );
      }
    } catch (error) {
      console.log(
        "deleteSetting error:",
        error
      );

      toast.error(
        error?.response?.data?.message ||
          "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  // =====================================================
  // GET TABLE CONTENT
  // =====================================================

  const getContent = (item) => {
    const config = CATEGORIES.find(
      (x) => x.value === item.category
    );

    if (!config) return "";

    return item[config.contentField] || "";
  };

  // =====================================================
  // GET TABLE SHOWING
  // =====================================================

  const getShowing = (item) => {
    const config = CATEGORIES.find(
      (x) => x.value === item.category
    );

    if (!config) return "";

    return item[config.showingField] || "";
  };

  // =====================================================
  // GET CATEGORY LABEL
  // =====================================================

  const getCategoryLabel = (value) => {
    return (
      CATEGORIES.find(
        (x) => x.value === value
      )?.label || "N/A"
    );
  };

  // =====================================================
  // RETURN
  // =====================================================

  return (
    <div className="main_wrap">

      {/* =================================================
          TITLE
      ================================================= */}

      <h2>Website Social Links</h2>

      {/* =================================================
          TOP
      ================================================= */}

      <div className="function-wrap funwrap">

        <div>
          <button
            type="button"
            className="btn-send"
            onClick={openAddModal}
          >
            Add New
          </button>
        </div>

        <div>
          <p>
            Total Records:{" "}
            {settingData.length}
          </p>
        </div>

      </div>

      {/* =================================================
          TABLE
      ================================================= */}

      <div className="table-container">

        <table className="table01">

          <thead>
            <tr>
              <th width="5%">
                Sr No.
              </th>

              <th>
                Category
              </th>

              <th>
                Link / Number / ID
              </th>

              <th>
                Showing
              </th>

              <th width="20%">
                Action
              </th>
            </tr>
          </thead>

          <tbody>

            {settingData.length > 0 ? (
              settingData.map(
                (item, index) => (
                  <tr
                    key={item._id || index}
                  >

                    <td>
                      {index + 1}
                    </td>

                    <td>
                      {getCategoryLabel(
                        item.category
                      )}
                    </td>

                    <td
                      style={{
                        wordBreak:
                          "break-all",
                      }}
                    >
                      {getContent(item) || "-"}
                    </td>

                    <td>
                      {getShowing(item) || "-"}
                    </td>

                    <td>

                      <button
                        type="button"
                        className="btn"
                        onClick={() =>
                          openEditModal(item)
                        }
                      >
                        Edit
                      </button>

                      <button
                        type="button"
                        className="btn"
                        style={{
                          marginLeft: "5px",
                        }}
                        onClick={() =>
                          openDeleteModal(
                            item._id
                          )
                        }
                      >
                        Delete
                      </button>

                    </td>

                  </tr>
                )
              )
            ) : (
              <tr>
                <td
                  colSpan="5"
                  className="align-C"
                >
                  <em>
                    No Record Found
                  </em>
                </td>
              </tr>
            )}

          </tbody>

        </table>

      </div>

      {/* =================================================
          ADD / EDIT MODAL
      ================================================= */}

      {showModal && (
        <div
          className="pop_bg"
          style={{
            height: "100%",
            width: "100%",
            display: "block",
          }}
        >

          <div className="pop_box pop_refer">

            {/* CLOSE */}

            <button
              type="button"
              className="close_pop"
              onClick={closeModal}
            >
              ×
            </button>

            {/* HEADER */}

            <div className="modal-header">

              <h3>
                {editId
                  ? "Edit Social Link"
                  : "Add New Social Link"}
              </h3>

            </div>

            {/* BODY */}

            <div className="modal-content">

              <div className="ticker-details">

                {/* CATEGORY */}

                <div
                  className="input-group"
                  style={{
                    marginBottom: "15px",
                  }}
                >

                  <label>
                    Category:
                  </label>

                  <select
                    className="w-100 p-2"
                    value={category}
                    onChange={
                      handleCategoryChange
                    }
                    disabled={!!editId}
                  >

                    {CATEGORIES.map(
                      (item) => (
                        <option
                          key={item.value}
                          value={item.value}
                        >
                          {item.label}
                        </option>
                      )
                    )}

                  </select>

                </div>

                {/* CONTENT */}

                <div
                  className="input-group"
                  style={{
                    marginBottom: "15px",
                  }}
                >

                  <label>
                    {getContentLabel()}:
                  </label>

                  <input
                    type={
                      selectedCategory.inputType
                    }
                    className="w-100 p-2"
                    value={socialValue}
                    onChange={(e) =>
                      setSocialValue(
                        e.target.value
                      )
                    }
                    placeholder={
                      selectedCategory.placeholder
                    }
                  />

                </div>

                {/* SHOWING */}

                <div
                  className="input-group"
                  style={{
                    marginBottom: "15px",
                  }}
                >

                  <label>
                    Showing Name:
                  </label>

                  <input
                    type="text"
                    className="w-100 p-2"
                    value={showingValue}
                    onChange={(e) =>
                      setShowingValue(
                        e.target.value
                      )
                    }
                    placeholder={
                      selectedCategory.label
                    }
                  />

                </div>

                {/* EXAMPLE */}

                <div
                  style={{
                    fontSize: "12px",
                    color: "#777",
                  }}
                >

                  {category ===
                    "telegram" && (
                    <>
                      Example:
                      https://t.me/abc
                    </>
                  )}

                  {category ===
                    "whatsapp" && (
                    <>
                      Example:
                      919876543210 or
                      https://wa.me/919876543210
                    </>
                  )}

                  {category ===
                    "email" && (
                    <>
                      Example:
                      example@gmail.com
                    </>
                  )}

                  {category ===
                    "skype" && (
                    <>
                      Example:
                      live:username
                    </>
                  )}

                  {category ===
                    "instagram" && (
                    <>
                      Example:
                      https://instagram.com/username
                    </>
                  )}

                  {category ===
                    "facebook" && (
                    <>
                      Example:
                      https://facebook.com/username
                    </>
                  )}

                </div>

              </div>

            </div>

            {/* FOOTER */}

            <div className="modal-footer">

              <div className="btn_box">

                <button
                  type="button"
                  className="btn-send"
                  style={{
                    width: "100%",
                  }}
                  onClick={onSubmit}
                  disabled={loading}
                >
                  {loading
                    ? "Loading..."
                    : editId
                    ? "Update"
                    : "Add New"}
                </button>

              </div>

            </div>

          </div>

        </div>
      )}

      {/* =================================================
          DELETE MODAL
      ================================================= */}

      {showDeleteModal && (
        <div
          className="modal"
          style={{
            display: "block",
            position: "fixed",
            inset: 0,
            width: "100%",
            height: "100%",
            zIndex: 80,
            background:
              "rgba(0,0,0,0.3)",
          }}
        >

          <div
            className="pop_box1"
            style={{
              maxWidth: "450px",
              margin: "100px auto",
              background: "#fff",
            }}
          >

            {/* HEADER */}

            <div
              className="modal-header"
              style={{
                background: "#dff0d8",
                padding: "10px 15px",
              }}
            >

              <h4>
                Delete
              </h4>

            </div>

            {/* BODY */}

            <div
              className="modal-body"
              style={{
                padding: "20px",
              }}
            >

              <p>
                Are you sure to delete
                this setting?
              </p>

              <div
                style={{
                  display: "flex",
                  justifyContent:
                    "center",
                  gap: "10px",
                  marginTop: "20px",
                }}
              >

                <button
                  type="button"
                  className="btn-send"
                  style={{
                    width: "100px",
                  }}
                  disabled={loading}
                  onClick={onDelete}
                >
                  {loading
                    ? "Loading..."
                    : "Confirm"}
                </button>

                <button
                  type="button"
                  className="btn-send"
                  style={{
                    width: "100px",
                  }}
                  onClick={
                    closeDeleteModal
                  }
                >
                  Cancel
                </button>

              </div>

            </div>

          </div>

        </div>
      )}

    </div>
  );
};

export default Setting;
